export default __webpack_public_path__ + "static/media/provesional_restoration_upper_14_4@2x.b2689f19.png";